module.exports = __webpack_public_path__ + "img/jbt9160_7_1999.prt.d57ef0ba.jpg";